import axios from 'axios';
import { getAxiosConfig } from '@/api/shared';

/*
 * Axios calls required by the Send a Letter process.
 *
 * These operations are against the `LetterFunnelController` in the infusionsoft module.
 */

const BASE_URL = '/app/letterFunnel';

export const createLetter = async () => {
    const { data } = await axios.post(BASE_URL);

    return data;
};

export const saveLetterSettings = async (marketingLetterId, assignedUserId, sendNotification) => {
    const saveLetterCommand = {
        assignedUserId,
        sendNotification,
    };

    return axios.put(`${BASE_URL}/${marketingLetterId}`, saveLetterCommand, getAxiosConfig);
};

export const syncLetterLabel = async (cell) => {
    const marketingLetterId = cell.value?.marketingLetterId ?? 0;
    const newName = cell.value?.name ?? '';

    if (marketingLetterId && newName) {
        await axios.put(`${BASE_URL}/${marketingLetterId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
